var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8825 22.1745L39.8821 22.1733L39.8821 22.1745H39.8825Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.882 22.1739C39.882 22.1738 39.8821 22.1736 39.8821 22.1733L17.9489 0.104004C16.9595 0.204863 15.9913 0.377832 15.0498 0.617598C6.39828 2.82033 0 20 0 20C0 20 27.9998 38.7371 31.1941 36.5753C31.8333 36.1428 32.4461 35.6743 33.0295 35.1728L20.0309 22.1739H39.882Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7826 20L15.3316 0.549133C6.53813 2.65202 0 10.5619 0 20C0 31.0456 8.95438 40 20 40C24.1898 40 28.0779 38.7108 31.2913 36.5087L14.7826 20H34.7826Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0213 29.5307L16.5787 28.3818L17.8794 26.0162L15.2271 26.5236L14.891 23.8441L13.0435 25.8148L11.1961 23.8441L10.86 26.5236L8.20769 26.0161L9.50839 28.3818L7.06573 29.5307L9.50839 30.6795L8.20769 33.0451L10.8601 32.5378L11.196 35.2172L13.0435 33.2465L14.891 35.2172L15.2271 32.5378L17.8793 33.0452L16.5786 30.6797L19.0213 29.5307Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3913 11.0924L15.6147 10.2569L16.5607 8.53633L14.6316 8.90539L14.3871 6.95648L13.0434 8.38984L11.6998 6.95648L11.4552 8.90539L9.5261 8.53633L10.4722 10.2569L8.69556 11.0924L13.0434 11.9621L17.3913 11.0924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.261 11.0923C18.261 13.9738 15.925 16.3098 13.0435 16.3098C10.162 16.3098 7.82611 13.9738 7.82611 11.0923",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNepal);
export default __webpack_public_path__ + "static/media/nepal.46d6a97b5a68745ffee636185af80610.svg";
export { ForwardRef as ReactComponent };